import axios from "axios";
import { getBackendBase } from "./backend";

export const API_BASE = `${getBackendBase()}/api`;

const TOKEN_KEY = "ajg_access_token";

export function getStoredToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch {
    return "";
  }
}

export function setStoredToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    // ignore (private mode etc.)
  }
}

// IMPORTANT: withCredentials is intentionally OMITTED.
// Browsers forbid Access-Control-Allow-Origin='*' with credentials=include,
// which makes any custom-domain deployment + CORS-wildcard backend fail.
// We use Authorization: Bearer headers instead — backend supports both cookies
// and bearer headers (see auth.py get_current_user).
const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    // If the token is no longer valid, drop it so the next page load shows /login.
    if (error?.response?.status === 401) {
      setStoredToken("");
    }
    return Promise.reject(error);
  }
);

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
